import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { LazyContent, LoadingPlaceholder } from "@faire/retailer-visitor-shared/features/Exclusivity/DetailsModal/__internal__/LazyContent";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { Modal } from "@faire/web--source/slate/Modal";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { Suspense } from "@faire/web--source/ui/Suspense";
import { usePrefetchQuery as usePrefetchExclusivityDetails } from "@faire/web-api--source/api/exclusivity-agreements/exclusivityAgreementToken/get-hooks";
import { QueryParameters as GetProtectionZoneQueryParameters } from "@faire/web-api--source/api/exclusivity-agreements/retailers/retailerToken/protection-zone/get";
import { usePrefetchQuery as usePrefetchProtectionZoneQuery } from "@faire/web-api--source/api/exclusivity-agreements/retailers/retailerToken/protection-zone/get-hooks";
import React, { useEffect } from "react";
export var ExclusivityDetailsModal = function(param) {
    var origin = param.origin, agreementToken = param.agreementToken, brandToken = param.brandToken, onClose = param.onClose;
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var prefetchDetails = usePrefetchExclusivityDetails();
    var prefetchProtectionZone = usePrefetchProtectionZoneQuery();
    var _useState = _sliced_to_array(useState(false), 2), showMap = _useState[0], setShowMap = _useState[1];
    var width = useResponsiveValue({
        mobileAndAbove: "100%",
        tabletAndAbove: "383px"
    });
    useEffect(function() {
        if (agreementToken) {
            prefetchDetails(agreementToken);
        }
        prefetchProtectionZone(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", GetProtectionZoneQueryParameters.build({
            brand_token: brandToken
        }));
    }, [
        agreementToken,
        brandToken,
        prefetchDetails,
        prefetchProtectionZone,
        retailerToken
    ]);
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: true,
        onClose: onClose,
        onBack: showMap ? function() {
            return setShowMap(false);
        } : undefined,
        stickyNav: true,
        width: width,
        align: "stretch",
        padding: "0",
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(LoadingPlaceholder, {}),
            children: /*#__PURE__*/ _jsx(LazyContent, {
                origin: origin,
                agreementToken: agreementToken,
                brandToken: brandToken,
                showMap: showMap,
                onShowMap: function() {
                    return setShowMap(true);
                },
                onClose: onClose
            })
        })
    });
};
